<script>
    import {Pie} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {getStyle} from '@coreui/coreui-pro/dist/js/coreui-utilities'

    export default {
        name: 'ChartPie',
        extends: Pie,
        props: ['height', 'width', 'sets', 'labels'],
        watch: {
            sets: {
                handler(val) {
                    this.build()
                },
                deep: true
            },
            labels: {
                handler(val) {
                    this.build()
                },
                deep: true
            }
        },
        mounted() {
            this.build()
        },
        methods: {
            build() {
                this.renderChart(
                    {
                        labels: this.labels,
                        datasets: this.sets
                    },
                    {
                        tooltips: {
                            enabled: false,
                            custom: CustomTooltips
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                    }
                )
            }
        }
    }
</script>
